import { IMessage, IUserInfo, ITopicType, TopicTypes, ITopic } from '../types';

export function message_with_sender_info(message: IMessage, userInfo: IUserInfo, topic: ITopic): IMessage {
    if (userInfo == null) {
        return { ...message }
    }
    const { userId, bossId } = userInfo
    const { sender_id, viewer_identity_id } = message
    const sender_is_me = (
        sender_id === userId ||
        (viewer_identity_id !== null && viewer_identity_id === bossId && topic.other_user_id !== bossId && topic.topic_type !== TopicTypes.CHANNEL && topic.topic_type !== TopicTypes.GROUP)
    )

    const sender_is_sys = (viewer_identity_id == 0 && topic.topic_type !== TopicTypes.SUPPORT)
    // console.log(message, sender_is_me)

    return { ...message, sender_is_me, sender_is_sys }
}
